export default "__VITE_ASSET__ALg0TZX$__"